import { createApp, inject } from 'vue';
import AppTemplate from './app.vue';
import router from './router/router.js';
// import { resolveVersion } from '@config/resolve-version.js';
import cliOptions from '@cliOptions';
import userConfig from '@userConfig';
// import { isFunction } from '@wholebodyapp/utils';
import { addSidebarItems } from './utils/add-sidebar-items.js';
import { setupGlobalComputed } from './utils/setup-global-computed.js';
import NotFound from './core-components/notfound.vue';

import '@wholebodyapp/design/index.scss';
import '@wholebodyapp/ui-components/styles.scss';
import { UiComponentsConfig } from '@wholebodyapp/ui-components/src/config/index.js';
import { createPinia } from 'pinia';

// UI loads, will proably add most of the components here at some point.
// For now... just the toast service,
import UiToastService from '@wholebodyapp/ui-components/src/toast-service/toast-plugin.js';

import { $http } from './http/http.js';

import './app.css';

/**
 *  This is going to be a bit trashy for a while, until we have the
 *  design pattern nailed for plugins, and what/how we want them to
 *  access on the main UI instance. For now, kinda following the
 *  Vuepress model, but… with some assumptions they can't make as
 *  a generic tool… Dont panic. This file will change ( and get neater)
 */


console.log('__cliOptions__\n', cliOptions, '\n');

console.log('__userConfig__\n', userConfig, '\n');


const app = createApp(AppTemplate);



app.config.globalProperties.$plugins = [];

/**
 *  We expect most plugins to need items in the sidebar nav.
 *  We're going to provide a POJO here with defaults, then
 *  put it into the plugin's install function so it can
 *  register it's items. After all the plubins are called,
 *  we'll save this as a global computed item with
 *  setupGlobalComputed().
 */
const sidebarItems = [
  { text: 'Admin',              children: [
    { text: 'UiTesting',        children: [
      { text: 'Playground 1',   path: '/uiplayground',     permissions: ['users.admin.super'] },
      { text: 'Playground 2',   path: '/uiplayground2',    permissions: ['users.admin.super'] },
    ]},
  ]},
];

const context = {proxy: 'tba'};

// copule of blobal provides.
app.provide('myGlobalVariable', 'how to access it?');
app.provide('$http', $http);


//
// ...................................................................................


console.log('app', {app} );

// abstract this out and handler the edge cases! SHould it be async?
 userConfig?.plugins?.forEach(plugin => {
  const resolvedPluginObject = (typeof plugin === 'function') ? plugin(app) : plugin;
  app.config.globalProperties.$plugins.push(resolvedPluginObject);
  app.use(resolvedPluginObject, { app, router, addSidebarItems: addSidebarItems(sidebarItems) });
});

console.log('sidebarItems!', sidebarItems);


// load the app globals!
const globals = setupGlobalComputed(app, userConfig, sidebarItems, context);

// add a redirect for empty routes. Notice it must be last!
router.addRoute({
  path: '/:pathMatch(.*)*',
  // redirect: '/',
  name: 'not-found',
  component: NotFound,
  meta: { layout: 'fullBleed', noAuth: true },
});

// got to add the routes before we start the router!
app.use(router);

// load up the UI component library configuration
// and maybe later, the components too?
app.use(UiComponentsConfig, {local: 'configHere'});
// compopent services...
app.use(UiToastService);

// setup our app-wide global data
//app.config.globalProperties.$version = resolveVersion();
app.config.globalProperties.$version = "10000";

// app.use(router);

// resolve the plugins from config

// load each plugin passing what we need rom the app
//


console.log('[main.js] app.config.globalProperties', app.config.globalProperties);

// use Pinia for global state...
const pinia = createPinia();
app.use(pinia);

// start it up!
app.mount('#app');

// https://medium.com/js-dojo/injecting-vue-plugins-c479370e2284
// https://medium.com/js-dojo/build-a-vue-plugin-e8a1427dc50a
// https://www.codemag.com/Article/2103071/The-Complete-Guide-to-Vue-3-Plug-ins-Part-2
